import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { QRCodeSVG } from "qrcode.react";
import { PAYMENTS, SOURCES } from "@/lib/api";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const tl = (n) => (n || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 }) + " TL";

// İşletmenin QR menü adresi (müşteri fişteki QR'ı okutup menüye gider).
export const menuUrl = (biz) => (biz?.slug ? `${window.location.origin}/menu/${biz.slug}` : "");

function qrBlock(biz) {
  const url = menuUrl(biz);
  if (!url) return "";
  let svg = "";
  try {
    svg = renderToStaticMarkup(createElement(QRCodeSVG, { value: url, size: 128, level: "M", marginSize: 1 }));
  } catch { return ""; }
  return `<div class="qr" style="text-align:center;margin:4px 0">
      <div style="display:inline-block;width:30mm;max-width:60%">${svg.replace("<svg ", '<svg style="width:100%;height:auto;display:block" ')}</div>
      <div style="font-size:10px">Menü için QR kodu okutun</div>
      <div style="font-size:9px;word-break:break-all">${esc(url.replace(/^https?:\/\//, ""))}</div>
    </div>`;
}

export function receiptHtml(order, biz, title = "") {
  const p = biz?.printer || {};
  const name = biz?.name || "Gazi Sepet";
  const extraHeader = p.header && p.header.trim() && p.header.trim() !== name ? p.header.trim() : "";
  const rows = order.items.map((i) => `<tr><td>${i.qty}x ${esc(i.name)}</td><td class="r">${tl(i.price * i.qty)}</td></tr>`).join("");
  return `<div class="rc">
    ${title ? `<div class="c b">${esc(title)}</div>` : ""}
    <div class="big" style="text-align:center;font-size:16px;font-weight:bold">${esc(name)}</div>
    ${extraHeader ? `<div class="c">${esc(extraHeader)}</div>` : ""}
    ${biz?.phone ? `<div class="c">${esc(biz.phone)}</div>` : ""}
    ${title ? "" : qrBlock(biz)}
    <hr/>
    <div>Sipariş No: <b>#${order.no}</b></div>
    <div>Tarih: ${new Date(order.created_at).toLocaleString("tr-TR")}</div>
    <div>Kaynak: ${esc(SOURCES[order.source] || order.source)}${order.table_name ? " / " + esc(order.table_name) : ""}</div>
    ${order.customer_name ? `<div>Müşteri: ${esc(order.customer_name)}</div>` : ""}
    ${order.customer_phone ? `<div>Tel: ${esc(order.customer_phone)}</div>` : ""}
    ${order.address ? `<div>Adres: ${esc(order.address)}</div>` : ""}
    <hr/><table>${rows}</table><hr/>
    <table><tr><td class="b big">TOPLAM</td><td class="r b big">${tl(order.total)}</td></tr></table>
    <div>Ödeme: <b>${esc(PAYMENTS[order.payment_method] || order.payment_method)}</b></div>
    ${order.note ? `<div>Not: ${esc(order.note)}</div>` : ""}
    <hr/><div class="c">${esc(p.footer || "")}</div>
  </div>`;
}

export function printReceipt(order, biz) {
  const p = biz?.printer || {};
  const width = p.paper === "58" ? "58mm" : "80mm";
  const parts = [];
  for (let i = 0; i < Math.max(1, p.copies || 1); i++) parts.push(receiptHtml(order, biz));
  if (p.kitchen_copy) parts.push(receiptHtml(order, biz, "MUTFAK FİŞİ"));
  const html = `<html><head><title>Fiş #${order.no}</title><style>
    @page { size: ${width} auto; margin: 2mm; }
    body { font-family: 'Courier New', monospace; font-size: 12px; width: ${width}; margin: 0; color: #000; }
    .rc { page-break-after: always; padding: 2mm; } .c { text-align: center; } .r { text-align: right; } .b { font-weight: bold; }
    .big { font-size: 15px; font-weight: bold; } table { width: 100%; border-collapse: collapse; } hr { border: 0; border-top: 1px dashed #000; }
  </style></head><body>${parts.join("")}</body></html>`;
  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  setTimeout(() => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    setTimeout(() => iframe.remove(), 2000);
  }, 300);
}
